import React, { Fragment, useState } from "react"
import { FaPlus } from "react-icons/fa"

import { haveAuth } from "utils"
import { StrMakeRequestModal, Button } from "components"
import classes from "./index.module.scss"

const StrHeader = (props) => {
  const { setStockTransferRequests } = props

  const [openMakeRequestModal, setOpenMakeRequestModal] = useState(false)

  return (
    <Fragment>
      {
        haveAuth(["createStockTransfer"]) &&
        <div className={classes["container"]}>
          <Button
            color="success"
            className={classes["button"]}
            onClick={() => setOpenMakeRequestModal(true)}
          >
            <FaPlus />
            <span className={classes["text"]}>
              ایجاد درخواست
            </span>
          </Button>
        </div>
      }
      <StrMakeRequestModal
        openMakeRequestModal={openMakeRequestModal}
        setOpenMakeRequestModal={setOpenMakeRequestModal}
        setStockTransferRequests={setStockTransferRequests}
      />
    </Fragment>
  )
}

export default StrHeader